import React from "react"
import styled, {css} from "styled-components"
import {Input, Toggle, Checkbox} from "@irati/ui/src/FormItem"
import {Body, H3} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"

const brands = ["Nike", "Nike", "Adidas", "Gucci", "Something else"]

export const FilterContent = () => {
  return (
    <Container>
      <Section>
        <Title>Price Per Month</Title>
        <InputsContainer>
          <InputWrapper>
            <InputLabel>Min price</InputLabel>
            <StyledInput name="minPrice" prefix="£" />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>Max price</InputLabel>
            <StyledInput name="maxPrice" prefix="£" />
          </InputWrapper>
        </InputsContainer>
      </Section>

      <Section>
        <Title>Promotions</Title>
        <PromotionRow>
          <Body>May Offers</Body>
          <Toggle name="mayOffers" onClick={() => {}} />
        </PromotionRow>
      </Section>

      <Section>
        <Title>Brands</Title>
        <BrandsContainer>
          {brands.map((brand, index) => (
            <Checkbox key={index} name={`brand-${index}`} onChange={() => {}}>
              {brand}
            </Checkbox>
          ))}
        </BrandsContainer>
      </Section>

      <ButtonContainer>
        <Button primary full onClick={() => {}}>
          Apply
        </Button>
        <Button variant="secondary" full onClick={() => {}}>
          Reset
        </Button>
      </ButtonContainer>
    </Container>
  )
}

const Container = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.two};
    background: ${theme.colors.greys.white};
  `}
`

const Section = styled.div`
  ${({theme}) => css`
    &:not(:last-child) {
      padding-bottom: ${theme.spacing.four};
      margin-bottom: ${theme.spacing.four};
      border-bottom: 1px solid ${theme.colors.greys.light};
    }
  `}
`

const Title = styled(H3)`
  ${({theme}) => css`
    margin-bottom: ${theme.spacing.one};
    font-size: 20px;
  `}
`

const InputsContainer = styled.div`
  ${({theme}) => css`
    display: flex;
    gap: ${theme.spacing.two};
    margin-top: ${theme.spacing.one};
  `}
`

const InputWrapper = styled.div`
  flex: 1;
`

const InputLabel = styled(Body)`
  ${({theme}) => css`
    color: ${theme.colors.greys.grey50};
    margin-bottom: ${theme.spacing.half};
    font-size: 16px;
  `}
`

const StyledInput = styled(Input)`
  ${({theme}) => css`
    input {
      height: 28px;
      border: 1px solid ${theme.colors.greys.light};
      border-radius: ${theme.border.radius.small};
      padding-left: ${theme.spacing.two};
    }
  `}
`

const PromotionRow = styled(Flex)`
  ${({theme}) => css`
    justify-content: space-between;
    align-items: center;
  `}
`

const BrandsContainer = styled.div`
  ${({theme}) => css`
    display: flex;
    flex-direction: column;
    margin-top: ${theme.spacing.one};
    gap: ${theme.spacing.one};

    .form-group {
      margin-bottom: 0;
    }
  `}
`

const StyledCheckbox = styled(Checkbox)`
  ${({theme}) => css`
    margin: 0;
    padding: ${theme.spacing.half} 0;
  `}
`

const ButtonContainer = styled.div`
  ${({theme}) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.one};
    margin-top: ${theme.spacing.two};
  `}
`
